import { motion } from "framer-motion";
import { fadeUp } from "./variants";

// Reveals its children once, as they scroll into view.
const Reveal = ({ as: Tag = "div", className, id, children }) => {
  const MotionTag = motion[Tag];
  return (
    <MotionTag
      id={id}
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: "some" }}
      variants={fadeUp}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
